import PropTypes from 'prop-types'
import styled from 'styled-components'
import breakpoint from 'tools/styled-components-breakpoint'
import { pixelise } from 'tools/style'
import Div from 'components/Div'
import { gutterSize, columns } from 'theme/default'

const getGutterSize = (fallback) => (props) => pixelise((props.gutterSize || fallback) / 2)

const Column = styled(Div)`
  position: relative;
  width: 100%;
  max-width: 100%;
  min-height: 1px;
  flex-basis: 0;
  flex-grow: 1;
  ${props => props.order ? `order: ${props.order};` : ''}
  ${breakpoint('mobile')`
    padding-right: ${getGutterSize(gutterSize.mobile)};
    padding-left: ${getGutterSize(gutterSize.mobile)};
    ${props => props.smHidden ? 'display: none;' : ''}
    ${props => props.sm ? `
      flex: 0 0 ${props.sm / columns * 100}%;
      max-width: ${props.sm / columns * 100}%;
    ` : ''}
    ${props => props.offsetSm ? `
      margin-left: ${props.offsetSm / columns * 100}%;
    ` : ''}
  `}
  ${breakpoint('tablet')`
    display: block;
    padding-right: ${getGutterSize(gutterSize.tablet)};
    padding-left: ${getGutterSize(gutterSize.tablet)};
    ${props => props.mdHidden ? 'display: none;' : ''}
    ${props => props.md ? `
      flex: 0 0 ${props.md / columns * 100}%;
      max-width: ${props.md / props.columns * 100}%;
    ` : ''}
    ${props => props.offsetMd ? `
      margin-left: ${props.offsetMd / columns * 100}%;
    ` : ''}
  `}
  ${breakpoint('desktop')`
    display: block;
    padding-right: ${getGutterSize(gutterSize.desktop)};
    padding-left: ${getGutterSize(gutterSize.desktop)};
    ${props => props.lgHidden ? 'display: none;' : ''}
    ${props => props.lg ? `
      flex: 0 0 ${props.lg / columns * 100}%;
      max-width: ${props.lg / columns * 100}%;
    ` : ''}
    ${props => props.offsetLg ? `
      margin-left: ${props.offsetLg / columns * 100}%;
    ` : ''}
  `}
`
Column.propTypes = {
  ...Div.propTypes,
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
  order: PropTypes.number,
  offsetSm: PropTypes.number,
  offsetMd: PropTypes.number,
  offsetLg: PropTypes.number,
  smHidden: PropTypes.bool,
  mdHidden: PropTypes.bool,
  lgHidden: PropTypes.bool
}

export default Column
